import styled, { keyframes } from "styled-components";
import { Search } from "@styled-icons/boxicons-regular/Search";
import { Delete } from "@styled-icons/fluentui-system-filled/Delete";
import { EditAlt } from "@styled-icons/boxicons-regular/EditAlt";


export const MainWrapper = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  min-height: 100vh;
  color: #fff;

  .dropdown-item {
    color: #333 !important;
  }

  .bgdark {
    background-color: #007bc6;
    margin-left: -15px;

    a {
      background-color: #05367f;
      margin-bottom: 1px;
      color: #fff;
    }

    hr{
      border-top: 1px solid #3b95f2;
      margin: 10px 0px;
    }
  }

  .btn-primary{
    background-color: #05367f;
    display: block;
    border: 0px;
    width: 100%;
  }

  .card {
    margin: 15px 0px;
  }
`;

export const MainContent = styled.div`
  background-color: #fff;
  padding: 15px;
  display: block;
  margin: 10px 0px;
  color: #333;

  .pull-right{
    position: relative;
    float: right;
  }
`;


export const SearchIcon = styled(Search)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;


export const DeleteIcon = styled(Delete)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;


export const EditIcon = styled(EditAlt)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;



/* ---------------------------------------------------------------------------
   Estados de carregamento e lista vazia.
   Esqueleto no formato do card: mostra o que está por vir em vez de um spinner
   solto, e evita o salto de layout quando os dados chegam.
   --------------------------------------------------------------------------- */

const brilho = keyframes`
  0%   { background-position: -420px 0; }
  100% { background-position: 420px 0; }
`;

export const CardEsqueleto = styled.div`
  background: #fff;
  border: 1px solid #e8eef5;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 24px;
  height: 196px;

  .barra {
    height: 12px;
    border-radius: 6px;
    background: #eef2f7;
    background-image: linear-gradient(90deg, #eef2f7 0%, #f7fafd 50%, #eef2f7 100%);
    background-size: 420px 100%;
    background-repeat: no-repeat;
    animation: ${brilho} 1.2s ease-in-out infinite;
  }

  .titulo { width: 55%; height: 15px; margin-bottom: 18px; }
  .linha  { width: 100%; margin-bottom: 10px; }
  .curta  { width: 70%; margin-bottom: 26px; }
  .botao  { width: 100%; height: 34px; border-radius: 8px; }
`;

export const AvisoCarregando = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 0 0 20px;
  font-size: 14px;
  color: #7a8fa6;

  .roda {
    width: 16px;
    height: 16px;
    border: 2px solid #e8eef5;
    border-top-color: #009bd9;
    border-radius: 50%;
    animation: girar 0.8s linear infinite;
  }

  @keyframes girar {
    to { transform: rotate(360deg); }
  }
`;

export const ListaVazia = styled.div`
  width: 100%;
  padding: 48px 20px;
  text-align: center;
  background: #fff;
  border: 1px dashed #cdd9e6;
  border-radius: 12px;

  i {
    font-size: 30px;
    color: #cdd9e6;
    display: block;
    margin-bottom: 12px;
  }

  strong {
    display: block;
    font-size: 16px;
    color: #1a2740;
    margin-bottom: 5px;
  }

  span {
    font-size: 13.5px;
    color: #8698ab;
  }
`;
